import { render } from "./BaseBreadcrumb.vue?vue&type=template&id=7541fedc&scoped=true"
import script from "./BaseBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./BaseBreadcrumb.vue?vue&type=script&lang=ts"

import "./BaseBreadcrumb.vue?vue&type=style&index=0&id=7541fedc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7541fedc"

export default script